import React, { PureComponent } from 'react';
import styled from 'styled-components';
import transparentize from 'polished/lib/color/transparentize';

import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import pxInRem from 'shared/helpers/styled-components/remHelper';
import { COLORS, FONT_FAMILIES } from 'shared/constants/theme';
import Button from '../Button';

const Wrapper = styled.div`
  position: absolute;
  background-color: ${transparentize(0.05, COLORS.white)};
  margin-left: 14px;
  margin-right: 14px;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid ${transparentize(0.05, COLORS.alto)};
  padding: 30px 130px;
  width: calc(100% - 28px);

  font-size: ${pxInRem(14)};
  font-family: ${FONT_FAMILIES.base};
  text-align: center;
  ${mediaQueries.toPhablet`
    margin-left: 7px;
    margin-right: 7px;
    padding: 25px 30px;
    width: calc(100% - 14px);
    
    font-size: ${pxInRem(13)};
  `};
`;

const StyledButton = styled(Button)`
  position: absolute;
  top: 4px;
  right: 6px;
  height: 16px;
  width: 16px;
  padding: 0;
  color: ${COLORS.mineShaft};
`;
export default class MapMessage extends PureComponent {
  render() {
    const { message, onClose: handleClose, className } = this.props;
    return (
      <Wrapper className={className}>
        {handleClose && (
          <StyledButton
            title="Close"
            onClick={handleClose}
            theme={Button.themes.blackTransparent}
          >
            <Button.children.SvgIcon
              xlink="/sprite.svg#cos-svg-close"
              width="11"
              height="11"
            />
          </StyledButton>
        )}
        {message}
      </Wrapper>
    );
  }
}
